import { cn } from "../../../Utils/helper";

export default function Button({
  text,
  icon,
  onClick,
  iconRight,
  maxWidth,
  className,
  disabled,
}) {
  return (
    <div
      className={cn(
        `flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full rounded-md ${
          maxWidth ? `max-w-${maxWidth}` : "w-full"
        } leading-none whitespace-nowrap border border-solid border-stone-200 min-h-[42px] ${
          disabled
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : " hover:opacity-50"
        } ${className}`,
        disabled && "opacity-70"
      )}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      onKeyPress={disabled ? undefined : (e) => e.key === "Enter" && onClick()}
    >
      {icon ? (
        <img
          loading="lazy"
          src={icon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      ) : (
        <div></div>
      )}
      <div className="flex items-center justify-center self-stretch m-auto text-sm">
        {text}
      </div>

      {iconRight ? (
        <img
          loading="lazy"
          src={iconRight}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      ) : (
        <div></div>
      )}
    </div>
  );
}
